import { defineMessages } from 'react-intl-next';
export let QuestionTypeMessage = /*#__PURE__*/function (QuestionTypeMessage) {
  QuestionTypeMessage["TextQuestionsGroupLabel"] = "TextQuestionsGroupLabel";
  QuestionTypeMessage["TextShortLabel"] = "TextShortLabel";
  QuestionTypeMessage["TextAttachmentLabel"] = "TextAttachmentLabel";
  QuestionTypeMessage["TextLongLabel"] = "TextLongLabel";
  QuestionTypeMessage["TextParagraphLabel"] = "TextParagraphLabel";
  QuestionTypeMessage["PlainTextParagraphLabel"] = "PlainTextParagraphLabel";
  QuestionTypeMessage["RichTextParagraphLabel"] = "RichTextParagraphLabel";
  QuestionTypeMessage["TextEmailLabel"] = "TextEmailLabel";
  QuestionTypeMessage["TextUrlLabel"] = "TextUrlLabel";
  QuestionTypeMessage["ChoiceCascadingLabel"] = "ChoiceCascadingLabel";
  QuestionTypeMessage["ChoiceQuestionsGroupLabel"] = "ChoiceQuestionsGroupLabel";
  QuestionTypeMessage["ChoiceSingleLabel"] = "ChoiceSingleLabel";
  QuestionTypeMessage["ChoiceMultipleLabel"] = "ChoiceMultipleLabel";
  QuestionTypeMessage["ChoiceDropdownLabel"] = "ChoiceDropdownLabel";
  QuestionTypeMessage["ChoiceDropdownMultipleLabel"] = "ChoiceDropdownMultipleLabel";
  QuestionTypeMessage["CmdbObjectLabel"] = "CmdbObjectLabel";
  QuestionTypeMessage["DateQuestionsGroupLabel"] = "DateQuestionsGroupLabel";
  QuestionTypeMessage["DateLabel"] = "DateLabel";
  QuestionTypeMessage["DateTimeLabel"] = "DateTimeLabel";
  QuestionTypeMessage["TimeLabel"] = "TimeLabel";
  QuestionTypeMessage["NumericQuestionsGroupLabel"] = "NumericQuestionsGroupLabel";
  QuestionTypeMessage["NumberLabel"] = "NumberLabel";
  QuestionTypeMessage["UserQuestionsGroupLabel"] = "UserQuestionsGroupLabel";
  QuestionTypeMessage["UserSingleLabel"] = "UserSingleLabel";
  QuestionTypeMessage["UserMultipleLabel"] = "UserMultipleLabel";
  QuestionTypeMessage["UnsupportedLabel"] = "UnsupportedLabel";
  return QuestionTypeMessage;
}({});
export const IntlQuestionTypeMessages = defineMessages({
  [QuestionTypeMessage.TextQuestionsGroupLabel]: {
    id: 'form-builder.QuestionType.TextQuestionsGroupLabel',
    defaultMessage: 'Text fields'
  },
  [QuestionTypeMessage.TextAttachmentLabel]: {
    id: 'form-builder.QuestionType.TextAttachmentLabel',
    defaultMessage: 'Attachment'
  },
  [QuestionTypeMessage.TextShortLabel]: {
    id: 'form-builder.QuestionType.TextShortLabel',
    defaultMessage: 'Short text'
  },
  [QuestionTypeMessage.TextLongLabel]: {
    id: 'form-builder.QuestionType.TextLongLabel',
    defaultMessage: 'Long text'
  },
  [QuestionTypeMessage.TextParagraphLabel]: {
    id: 'form-builder.QuestionType.TextParagraphLabel',
    defaultMessage: 'Paragraph'
  },
  [QuestionTypeMessage.PlainTextParagraphLabel]: {
    id: 'form-builder.QuestionType.PlainTextParagraphLabel',
    defaultMessage: 'Paragraph (Plain text)'
  },
  [QuestionTypeMessage.RichTextParagraphLabel]: {
    id: 'form-builder.QuestionType.RichTextParagraphLabel',
    defaultMessage: 'Paragraph'
  },
  [QuestionTypeMessage.TextEmailLabel]: {
    id: 'form-builder.QuestionType.TextEmailLabel',
    defaultMessage: 'Email'
  },
  [QuestionTypeMessage.TextUrlLabel]: {
    id: 'form-builder.QuestionType.TextUrlLabel',
    defaultMessage: 'URL'
  },
  [QuestionTypeMessage.ChoiceQuestionsGroupLabel]: {
    id: 'form-builder.QuestionType.ChoiceQuestionsGroupLabel',
    defaultMessage: 'Choice fields'
  },
  [QuestionTypeMessage.ChoiceCascadingLabel]: {
    id: 'form-builder.QuestionType.ChoiceCascadingLabel',
    defaultMessage: 'Cascading dropdown'
  },
  [QuestionTypeMessage.ChoiceSingleLabel]: {
    id: 'form-builder.QuestionType.ChoiceSingleLabel',
    defaultMessage: 'Radio buttons'
  },
  [QuestionTypeMessage.ChoiceMultipleLabel]: {
    id: 'form-builder.QuestionType.ChoiceMultipleLabel',
    defaultMessage: 'Checkboxes'
  },
  [QuestionTypeMessage.ChoiceDropdownLabel]: {
    id: 'form-builder.QuestionType.ChoiceDropdownLabel',
    defaultMessage: 'Dropdown'
  },
  [QuestionTypeMessage.ChoiceDropdownMultipleLabel]: {
    id: 'form-builder.QuestionType.ChoiceDropdownMultipleLabel',
    defaultMessage: 'Multiselect dropdown'
  },
  [QuestionTypeMessage.CmdbObjectLabel]: {
    id: 'form-builder.QuestionType.CmdbObjectLabel',
    defaultMessage: 'Assets object/s'
  },
  [QuestionTypeMessage.DateQuestionsGroupLabel]: {
    id: 'form-builder.QuestionType.DateQuestionsGroupLabel',
    defaultMessage: 'Date fields'
  },
  [QuestionTypeMessage.DateLabel]: {
    id: 'form-builder.QuestionType.DateLabel',
    defaultMessage: 'Date'
  },
  [QuestionTypeMessage.DateTimeLabel]: {
    id: 'form-builder.QuestionType.DateTimeLabel',
    defaultMessage: 'Date & Time'
  },
  [QuestionTypeMessage.TimeLabel]: {
    id: 'form-builder.QuestionType.TimeLabel',
    defaultMessage: 'Time'
  },
  [QuestionTypeMessage.NumericQuestionsGroupLabel]: {
    id: 'form-builder.QuestionType.NumericQuestionsGroupLabel',
    defaultMessage: 'Numeric fields'
  },
  [QuestionTypeMessage.NumberLabel]: {
    id: 'form-builder.QuestionType.NumberLabel',
    defaultMessage: 'Number'
  },
  [QuestionTypeMessage.UserQuestionsGroupLabel]: {
    id: 'form-builder.QuestionType.UserQuestionsGroupLabel',
    defaultMessage: 'User fields'
  },
  [QuestionTypeMessage.UserSingleLabel]: {
    id: 'form-builder.QuestionType.UserSingleLabel',
    defaultMessage: 'Single user'
  },
  [QuestionTypeMessage.UserMultipleLabel]: {
    id: 'form-builder.QuestionType.UserMultipleLabel',
    defaultMessage: 'Multiple users'
  },
  [QuestionTypeMessage.UnsupportedLabel]: {
    id: 'form-builder.QuestionType.UnsupportedLabel',
    defaultMessage: 'Unsupported'
  }
});